export default "__VITE_ASSET__f6b7de61__"